<mat-toolbar class="bar-custom">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <button class="btn-custom" (click)="newSupplier()">New Supplier</button>
      </div>
    </div>
  </div>
</mat-toolbar>
